module.exports = __webpack_public_path__ + "img/startup1.2816099d.png";